import { Component, inject, OnInit } from '@angular/core';
import { ClientListEntry } from '../../api/types';
import { ColumnDescription, TableComponent } from '../components/table';
import { StateService } from '../../api/state';

@Component({
  selector: 'app-client-list',
  template: `
    <ng-template #rowTemplate let-value>
      <!-- Enable type checking in the template -->
      @let entry = identity(value);
      <tr>
        <td>{{ entry.clientId }}</td>
        <td>{{ entry.name }}</td>
        <td>{{ entry.description }}</td>
        <td><a class="syn-link inverted" [href]="entry.baseUrl">{{ entry.baseUrl }}</a></td>
        <td style="white-space: nowrap">{{ entry.lastLoginTimestamp }}</td>
        <td>{{ entry.admins.join(", ") }}</td>
      </tr>
    </ng-template>
    <app-table
      [columns]="columns"
      [values]="clients()"
      [loading]="loading()"
      [clickable]="true"
      [rowTemplate]="rowTemplate"
    />
  `,
  styles: [
    `
      app-table {
        width: 100%;
      }
    `,
  ],
  imports: [TableComponent],
})
export class ClientListComponent implements OnInit {
  state = inject(StateService);

  clients = this.state.clientList;
  loading = this.state.clientListLoading;

  columns: ColumnDescription<ClientListEntry>[] = [
    {
      label: $localize`:@@client-id:Client ID`,
      getField: (client) => client.clientId,
      style: 'width: 15%',
    },
    {
      label: $localize`:@@name:Name`,
      getField: (client) => client.name,
      style: 'width: 15%',
    },
    {
      label: $localize`:@@description:Description`,
      getField: (client) => client.description,
      style: 'width: 15%',
    },
    {
      label: $localize`:@@service-url:Service URL`,
      getField: (client) => client.baseUrl,
      style: 'width: 23%',
    },
    {
      label: $localize`:@@last-login:Last Login`,
      getField: (client) => client.lastLoginTimestamp,
      style: 'width: 12%',
    },
    {
      label: $localize`:@@client-admins:Client Admins`,
      getField: (client) => client.admins.join(', '),
      style: 'width: 25%',
    },
  ];

  ngOnInit(): void {
    this.state.queryClientList();
  }

  identity(client: ClientListEntry) {
    return client;
  }
}
